import "./DetailsPage.css";
import React, { useEffect, useState } from "react";
import { useConfigs } from "./components/ConfigsContext";
import { useLocation } from "react-router-dom";
import ReactHtmlParser from "html-react-parser";
import TabComponent from "./components/TabComponent";

import "./Global.js";

const strapiServerUrl = window.strapiServerUrl;

function DetailsPage() {
  const { loading, error, data } = useConfigs();
  const [promotionData, setPromotionData] = useState([]);
  const location = useLocation();

  useEffect(() => {
    if (data) {
      const promotionData = data.promotions.data;
      setPromotionData(promotionData);
    }
  }, [data]);

  useEffect(() => {
    const section = location.state?.sectionId; // Get the section ID from the passed state
    if (section) {
      const element = document.getElementById(section);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({
            behavior: "smooth",
            block: "center",
            offset: 200,
          });
        }, 100); // Delay the scroll to ensure the component has rendered
      }
    }
  }, [promotionData, location.state]);

  return (
    <div className="promotions-details-container">
      {loading ? (
        <div className="center">Loading...</div>
      ) : error ? (
        <div>Error: {error.message}</div>
      ) : (
        promotionData.length !== 0 &&
        promotionData.map((promo, index) => (
          <div
            className="promotion-details"
            id={promo.attributes.promotion_name}
            key={index}
          >
            <div className="promotion-detail-section">
              <div
                className="promotion-detail-image"
                style={
                  promo.attributes.section_color && {
                    backgroundColor: promo.attributes.section_color,
                  }
                }
              >
                <img
                  src={`${strapiServerUrl}${promo.attributes.promo_image.data.attributes.url}`}
                  alt="Promotion 1"
                />
              </div>
              <div
                className="promotion-detail"
                style={
                  promo.attributes.section_color
                    ? { border: `2px solid ${promo.attributes.section_color}` }
                    : {}
                }
              >
                <h2 className="promotion-detail-header">
                  {promo.attributes.promotion_name}
                </h2>
                {promo.attributes.promotion_details.data.length !== 0 && (
                  <div
                    className="promotion--cards"
                    style={{
                      "--clr-scroll": promo.attributes.section_color,
                      display: "flex",
                    }}
                  >
                    {promo.attributes.promotion_details.data.map(
                      (item, index) => (
                        <div
                          className="promotion--card"
                          key={index}
                          style={{
                            background: promo.attributes.section_color
                              ? `linear-gradient(180deg, ${promo.attributes.section_color}, transparent)`
                              : "initial",
                          }}
                        >
                          <div className="promotion--card-details">
                            <h3 style={{ marginBottom: "20px" }}>
                              {item.attributes.title}
                            </h3>
                            <div className="card-benifits">
                              <ul>
                                {item.attributes.details.benifits &&
                                  Object.entries(
                                    item.attributes.details.benifits
                                  ).map(([key, value]) => (
                                    <li key={key}>{value}</li>
                                  ))}
                              </ul>
                            </div>
                            <div className="card-properties">
                              {item.attributes.details.properties &&
                                Object.entries(
                                  item.attributes.details.properties
                                ).map(([key, value]) => (
                                  <p key={key}>{value}</p>
                                ))}
                            </div>
                          </div>
                        </div>
                      )
                    )}
                  </div>
                )}
                {promo.attributes.promotion_tabs.data.length !== 0 && (
                  <div className="promotion-tab" style={{ display: "flex" }}>
                    <TabComponent data={promo.attributes.promotion_tabs.data} />
                  </div>
                )}
              </div>
            </div>
            {promo.attributes.promo_detail && (
              <div
                className="promotion--card-description"
                style={{ display: "block" }}
              >
                {ReactHtmlParser(promo.attributes.promo_detail)}
              </div>
            )}
          </div>
        ))
      )}
    </div>
  );
}

export default DetailsPage;
